import { DELETE, GET, POST } from "@/utils/http";

const ADMIN_BASE_URI = "/customer-requests";

export const CustomerRequestService = {
  getDetail(
    customerRequestId: string,
  ): Promise<CustomerRequestDetail | null | undefined> {
    return GET<CustomerRequestDetail>(
      `${ADMIN_BASE_URI}/detail/${customerRequestId}`,
      undefined,
      true,
    );
  },
  search(
    request: SearchCustomerRequestRequest,
  ): Promise<SearchContactResponse | null | undefined> {
    return POST<SearchContactResponse>(`${ADMIN_BASE_URI}/search`, request);
  },
  delete(
    customerRequestId: number,
  ): Promise<SuccessResponse | null | undefined> {
    return DELETE<SuccessResponse>(
      `${ADMIN_BASE_URI}/delete/${customerRequestId}`,
      undefined,
      true,
    );
  },
  setState(params: {
    customerRequestId: number;
    state: number;
    remark?: string;
  }): Promise<CustomerRequestDetail | null | undefined> {
    return GET<CustomerRequestDetail>(
      `${ADMIN_BASE_URI}/state`,
      { params },
      true,
    );
  },
  export(data?: any) {
    return POST<Blob>(`${ADMIN_BASE_URI}/export`, data, {
      responseType: "blob",
    });
  },
};
